/**
 * Nettoyage de l'identifiant saisi à l'ajout d'un capteur (DEV-2536).
 *
 * Même règle que le serveur (homeys-data,
 * `api/sources/source/mixins/normaliser_idsource.py`) :
 * 1. les caractères invisibles (espaces de largeur nulle, BOM, trait d'union
 *    conditionnel) sont retirés partout ;
 * 2. les blancs de tête et de fin sont retirés ;
 * 3. si la saisie n'est faite que de groupes hexadécimaux séparés par des
 *    blancs, des deux-points ou des tirets, les séparateurs sont retirés.
 *
 * La casse est conservée : certains opérateurs y sont sensibles. Un libellé
 * collé n'est pas deviné : la recherche répond alors « format non reconnu ».
 */
// Alternance plutôt que classe : U+200D (liant) dans une classe est signalé par ESLint
const INVISIBLES = /\u00AD|\u200B|\u200C|\u200D|\u2060|\uFEFF/g
// Blancs, deux-points, tiret ASCII et tirets typographiques (U+2010 à U+2015)
const SEPARATEURS = "\\s:\\-\\u2010-\\u2015"
const GROUPES_HEXA = new RegExp(
    `^[0-9A-Fa-f]+(?:[${SEPARATEURS}]+[0-9A-Fa-f]+)+$`
)
const SEPARATEUR = new RegExp(`[${SEPARATEURS}]+`, "g")

/**
 * Motif rendu par la recherche (`source.find_config.request`, code 422) quand
 * aucun opérateur ne reconnaît le format de l'identifiant.
 */
export const MOTIF_FORMAT_NON_RECONNU = "format_non_reconnu"

export function normaliserIdsource(saisie?: string | null): string {
    if (typeof saisie !== "string") return ""
    const nettoye = saisie.replace(INVISIBLES, "").trim()
    return GROUPES_HEXA.test(nettoye)
        ? nettoye.replace(SEPARATEUR, "")
        : nettoye
}

/**
 * Vrai si la réponse de la recherche porte le motif « format non reconnu »,
 * quel que soit l'emballage (`result`, `data.result` ou racine).
 */
export function estFormatNonReconnu(reponse: unknown): boolean {
    type Emballage = {
        motif?: unknown
        result?: { motif?: unknown }
        data?: { motif?: unknown; result?: { motif?: unknown } }
    }
    const r = reponse as Emballage | null | undefined
    const motif =
        r?.data?.result?.motif ?? r?.result?.motif ?? r?.data?.motif ?? r?.motif
    return motif === MOTIF_FORMAT_NON_RECONNU
}
